<!--
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: zyb
 * @LastEditTime: 2022-03-31 17:08:03
 * @FilePath: \dev_2.0\src\views\home\childComp\HomeTitle\HomeTitle.vue
 * @Description: 
-->
<template>
  <div :class="screenWidth > 765 ? 'title-box-pc' : 'title-box-mb'">
    <div :class="screenWidth > 765 ? 'title-pc' : 'title-mb'" :title="title">
      {{ title }}
    </div>
    <div :class="screenWidth > 765 ? 'tips-pc' : 'tips-mb'" v-if="info">
      {{ info }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "screenWidth", "info"],
};
</script>

<style lang="scss" scoped>
.title-box-pc,
.title-box-mb {
  text-align: center;
}
.title-box-pc {
  margin-top: 133rem / $rem;
}
.title-box-mb {
  margin-bottom: 49rem / $mbrem;
}
.title-pc {
  width: 388rem / $rem;
  font-size: 48rem / $rem;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 20rem / $rem;
  font-weight: 700;
}
.title-mb {
  font-size: 48rem / $mbrem;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  color: #000000;
}
.tips-mb {
  font-size: 22rem / $mbrem;
}
.tips-mb{
  font-size: 22rem/$mbrem;
}
.tips-pc {
  font-size: 14rem / $rem;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: center;
  color: #000000;
}
</style>